import React from 'react';
import HistoryRoom from "../HistoryRoom/HistoryRoom.jsx";

const HistoryRoomAdmin = function () {
    return <div className={`belote-wrapper board-V1 card-back-V1 card-front-V1`}>
        <HistoryRoom
            isActive={true}
        />
    </div>
}
export default HistoryRoomAdmin